(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-vendor-html"] = factory(require("mggp-player"));
	else
		root["mggp-vendor-html"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-vendor-html.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-vendor-html.js":
/*!*********************************!*\
  !*** ./src/mggp-vendor-html.js ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by User on 29/11/2016.
 */
var Vendor = __webpack_require__(/*! mggp-player */ "mggp-player").Vendor;
var AddonError = __webpack_require__(/*! mggp-player */ "mggp-player").AddonError;

/**
 * @class MggpVendorDash
 */
function MggpVendorHtml(pPlayer, pConfig) {
	Vendor.apply(this, arguments);

	var self = this;
	var playing = false;
	var iframe = null;
	var duration = 0;
	var position = 0;
	var lastTimestamp = 0;
	var loaded = false;
	var autoplay = false;
	var mediaBeforeCompleteEmited = false;

	this.dispose = function () {
		self.player.off('player:timeUpdate', onTimeUpdate);
		if (iframe) {
			iframe.removeEventListener('load', onIframeLoadingEvent, false);
			iframe.removeEventListener('error', onIframeLoadingEvent, false);
			if (iframe.parentNode) {
				iframe.parentNode.removeChild(iframe);
			}
		}
		playing = false;
		loaded = false;
		self.emit('vendorDestroy');
	};

	this.load = function (src, videoInfo, options) {
		if (!src || !src && !videoInfo || videoInfo && !videoInfo.src || options.duration === undefined) {
			self.emit('error');
			return;
		}
		if (options) {
			if (!self.checkOptions(options)) {
				return;
			}
		} else {
			options = {};
		}
		setState(5);
		autoplay = options.autoplay;

		if (!iframe) {
			createIframe();
		}

		duration = options.duration;
		self.set('duration', duration);
		self.set('position', 0);

		iframe.addEventListener('load', onIframeLoadingEvent, false);
		iframe.addEventListener('error', onIframeLoadingEvent, false);

		setState(3);
		if (src) {
			iframe.src = src;
		} else if (videoInfo.src) {
			iframe.src = src;
		}

		self.player.on('player:timeUpdate', onTimeUpdate);
	};

	this.play = function () {
		setState(1);
		if (loaded) {
			playing = true;
		}
	};

	this.pause = function () {
		setState(2);
		playing = false;
	};

	this.stop = function () {
		this.dispose();
	};

	this.togglePlayPause = function () {
		if (playing) {
			self.pause();
		} else {
			self.play();
		}
	};

	this.seekTo = function (seconds) {
		if (seconds > duration) {
			seconds = duration;
		} else if (seconds < 0) {
			seconds = 0;
		}
		position = seconds;
		self.set('position', position);
	};

	this.setVolume = function (pVolume) {};

	this.mute = function () {};

	this.unMute = function () {};

	this.getPlayableElement = function () {
		return _video;
	};

	self.emit('vendorCreate');

	function setState(pNewState) {
		self.set('state', pNewState);
		self.emit('stateChange', pNewState);
	}

	function createIframe() {
		iframe = document.createElement('iframe');
		iframe.style.border = 'none';
		iframe.frameborder = '0';
		iframe.scrolling = 'no';
		iframe.style.overflow = 'hidden';
		iframe.allowtransparency = true;
		iframe.style.backgroundColor = 'transparent';
		iframe.style.width = '100%';
		iframe.style.height = '100%';
		iframe.setAttribute("data-adl-consent", "ignore");
		self.container.appendChild(iframe);
	}

	function onIframeLoadingEvent(event) {
		iframe.removeEventListener('load', onIframeLoadingEvent, false);
		iframe.removeEventListener('error', onIframeLoadingEvent, false);
		setState(5);
		switch (event.type) {
			case 'load':
				loaded = true;
				self.emit('mediaCanPlay');
				self.emit('loadedFraction', 1);
				if (autoplay) {
					self.play();
				}
				break;
			case 'error':
				self.emit('mediaError');
				self.dispose();
				break;
		}
	}

	function onTimeUpdate() {
		var timestamp = new Date().getTime() / 1000;
		if (lastTimestamp > 0 && playing) {
			position += timestamp - lastTimestamp;
			if (duration - position <= 1 && !mediaBeforeCompleteEmited) {
				mediaBeforeCompleteEmited = true;
				self.emit('mediaBeforeComplete');
			}
			if (position >= duration) {
				setState(0);
				playing = false;
			}

			self.set('position', position);
		}
		lastTimestamp = timestamp;
	}
}

MggpVendorHtml.prototype = Object.create(Vendor.prototype);
MggpVendorHtml.prototype.constructor = MggpVendorHtml;

MggpVendorHtml.canPlay = function (pType, pConfig) {
	return true;
};

MggpVendorHtml.priority = 0;
MggpVendorHtml.mimeTypes = ["html", "htm"];

module.exports = MggpVendorHtml;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});